import type { TestCaseTItem } from "../../core";
import { tCasesPredicateFind } from "../predicateFind";

export type TCasesAssertChildTitleUniqArg = {
  root: TestCaseTItem;
  parentId: TestCaseTItem["id"];
  title: string;
};
/**
 * should be used to check whether a given title is unique\
 * among the children of a given parentId (and whether node\
 * with parentId is a dir). So it will return true only if:
 * - node with parentId exists
 * - it is dir
 * - none of its children has this title
 */
export const tCasesAssertChildTitleUniq = (arg: TCasesAssertChildTitleUniqArg): boolean => {
  const { title, parentId, root } = arg;

  const maybeParent = tCasesPredicateFind({ rootTreeItem: root, predicate: (it) => it.id === parentId });
  if (maybeParent === null || maybeParent.type !== "folder") return false;

  return maybeParent.children.some((child) => child.title.toLowerCase() === title.toLowerCase()) === false;
};
